module.exports = __webpack_public_path__ + "img/logo_syntein.6d1fd533.svg";